module.exports = __webpack_public_path__ + "img/modal-left-1.1a11d968.png";